// Brand assets — centralized so we can swap them in one place.
export const BRAND = {
  banner: "/brand/gameflow-banner.jpg",
  logoIcon: "/brand/gameflow-logo-64.png",
  logoLarge: "/brand/gameflow-logo.png",
};
